/**
 * Works out what type of device this is roughly, based on media queries
 * @param {string} device The device type: such as mobile or desktop
 * @returns {boolean}
 */
export const isDevice = (device: string): boolean => {
  return getComputedStyle(document.documentElement).getPropertyValue('--device-type') == device;
}

/**
 * Is the current device exceeding the 'desktop' media query?
 * @returns {boolean}
 */
export const isDesktop = (): boolean => isDevice('desktop');

/**
 * Is the current device within the mobile breakpoint?
 * @returns {boolean}
 */
export const isMobile = (): boolean => isDevice('mobile');

/**
 * Is the current device within the tablet breakpoint?
 * @returns {boolean}
 */
export const isTablet = (): boolean => isDevice('tablet');